import { render, staticRenderFns } from "./EventOverview.vue?vue&type=template&id=cd186e52&"
import script from "./EventOverview.vue?vue&type=script&lang=js&"
export * from "./EventOverview.vue?vue&type=script&lang=js&"
import style0 from "./EventOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports